import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state(){
    return {
      // 就是公共的数据，所有的组件都可以直接使用
      token:"",
      userInfo:{
        nickName:"",
        avatar:"",
        phont:""
      }
    }
  },
  mutations:{
    updateToken(state,token){
        state.token =token
    },
    saveUserInfo(state,userInfo){
      state.userInfo=userInfo
    }
  }
})
export default store